module.exports = __webpack_public_path__ + "static/media/3.c3d4bfb7.svg";